import styled from '@emotion/styled';
import Box from '@mui/material/Box';

export const GalleryContainer = styled(Box)(({ theme }) => ({
  '.image-gallery-svg': {
    color: theme.palette.primary.main,

    '&:hover': {
      color: theme.palette.primary.main
    }
  },

  '.image-gallery-thumbnail.active, .image-gallery-thumbnail:hover, .image-gallery-thumbnail:focus': {
    border: `4px solid ${theme.palette.primary.main}`
  },

  '.image-gallery-thumbnail': {
    width: '108px !important'
  },
  '.image-gallery-slide .gatsby-image-wrapper div': {
    height: '40vh !important'
  },
  '@media (max-width: 768px)': {
    '.image-gallery-thumbnail': {
      border: '3px solid transparent',
      width: '108px !important'
    }
  }

}));
